const VoucherRecipients = {
  All: "all",
  SelectedAccounts: "selected-accounts",
  UploadCsv: "upload-csv",
  UploadCsvWithUnregisteredUsers: "upload-csv-with-unregistered-users",
};

export default VoucherRecipients;
